module.exports = __webpack_public_path__ + "static/img/6.7fe2159.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/6.png
// module id = NJFr
// module chunks = 0